import { useLocation } from "react-router-dom";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";

const WA_NUMBER = "393206062816";
const WA_MESSAGE = encodeURIComponent("Ciao! Vorrei informazioni sul noleggio auto a Pontedera.");

export const FloatingWhatsApp = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;

  return (
    <a
      href={`https://wa.me/${WA_NUMBER}?text=${WA_MESSAGE}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Scrivici su WhatsApp"
      data-testid="floating-whatsapp"
      className="fixed bottom-5 right-5 z-[60] flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg shadow-black/40 hover:scale-110 active:scale-95 transition-transform"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
      <WhatsAppIcon className="w-7 h-7 relative" />
    </a>
  );
};
